import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { bindTrigger, usePopupState } from 'material-ui-popup-state/hooks'
import { FormattedMessage } from 'react-intl'

import { Badge, Button } from '@mui/material'

import ArrowDownIcon from 'app/assets/icons/arrow-down-white.svg'
import Avatar from 'app/components/base/Avatar'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import useUserNotifications from 'app/hooks/useUserNotifications'
import useAuthStore, { getAuthUser } from 'app/store/auth.store'

import HeaderButtonContainer from '../layouts/HeaderButtonContainer'

const MyAccountPopup = dynamic(
  () => import('~/components/popups/MyAccountPopup'),
  {
    ssr: false
  }
)

const MyAccountButton = () => {
  const router = useRouter()
  const user = useAuthStore(getAuthUser)

  const { isNotifications } = useUserNotifications()

  const popupState = usePopupState({
    variant: 'popper',
    popupId: 'myAccountMenu'
  })

  useEffect(() => {
    popupState.close()
  }, [router.asPath])

  return (
    <HeaderButtonContainer>
      <Button
        variant="text"
        endIcon={<ArrowDownIcon />}
        sx={{ color: 'background.default', py: 0.5, border: 'none' }}
        {...bindTrigger(popupState)}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Badge
            color="secondary"
            variant="dot"
            invisible={!isNotifications}
            sx={{
              '.MuiBadge-badge': {
                top: 6,
                right: 3,
                minWidth: 14,
                height: 14
              }
            }}
          >
            <Avatar
              src={user?.avatar?.url}
              width={32}
              height={32}
              sizes="100px"
              sx={{
                ...(user?.avatar?.url && {
                  border: '1px solid',
                  borderColor: 'background.default',
                  backgroundColor: 'inherit'
                })
              }}
            />
          </Badge>

          <Text size={{ xs: 'body1' }} component="span" noWrap>
            <FormattedMessage defaultMessage="My Account" />
          </Text>
        </Stack>
      </Button>

      {popupState.isOpen && <MyAccountPopup popupState={popupState} />}
    </HeaderButtonContainer>
  )
}

export default MyAccountButton
